import resource from 'resource-axios'
import axios from 'axios'

const _base = 'rpc/'
const customActions = {
	login: (payload) =>
		axios.post(`${_base}login`, payload)
}
export const users = resource('/rpc/login', customActions, axios)
